module.exports = __webpack_public_path__ + "img/course_center_bg.377150ad.png";